/* eslint-disable @typescript-eslint/naming-convention */

export interface User {
  id?: number;
  username: string;
  first_name?: string;
  last_name?: string;
  email: string;
  token: string;
  permissions: string[];
  roles: string[];
  anonymous: boolean
}

export function newUser (): User {
  return {
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    token: '',
    permissions: [],
    roles: [],
    anonymous: true,
  }
}
